import React, { useContext, useEffect, useState } from "react";
import "./Sidebar.css";
import { Nav, Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAnglesDown,
  faAnglesRight,
  faBell,
  faBug,
  faBus,
  faDice,
  faGamepad,
  faGauge,
  faHandHoldingHand,
  faLeaf,
  faLocationDot,
  faPeopleArrows,
  faPerson,
  faTicket,
  faTint,
  faTShirt,
  faUserTie,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../utils/context";
import { findAllSideBar } from "../../utils/apis/dashboard/dashboard";
import { faWordpress } from "@fortawesome/free-brands-svg-icons";

function Sidebar() {
  const { usertype } = useContext(Context);
  const location = useLocation();
  const [activeKey, setActiveKey] = useState("0");
  const [activeLink, setActiveLink] = useState(location.pathname);

  const handleNavClick = (path) => {
    setActiveLink(path);
  };

  const { UnauthorizedLogOut } = useContext(Context);
  const [data, setData] = useState([]);
  const getDataAll = async () => {
    // try {
    //   const response = await findAllSideBar();
    //   await setData(response?.data?.data);
    // } catch (error) {
    //   console.error(error.message);
    //   await UnauthorizedLogOut(error);
    // }
  };
  useEffect(() => {
    getDataAll();
    const intervalId = setInterval(() => {
      getDataAll();
    }, 10000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  return (
    <section className="Sidebar">
      <Nav className="sidebar-link-holder">
        {/* Master Link */}

        {/* User Link */}
        {/* <Nav.Link
          className={activeLink === "/view-list" ? "active" : ""}
          onClick={() => handleNavClick("/view-list")}
          as={Link}
          to={"/view-list"}
        >
          <FontAwesomeIcon icon={faAnglesRight} className="me-2" /> User
        </Nav.Link> */}

        {/* View All Played Game Link */}
        <Nav.Link
          className={activeLink === "/dashboard" ? "active" : ""}
          onClick={() => handleNavClick("/dashboard")}
          as={Link}
          to={"/dashboard"}
        >
          <FontAwesomeIcon icon={faGauge} className="me-2" />
          Dashboard
        </Nav.Link>

        {usertype != "Agent" ? (
          <Accordion activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}>
            <Accordion.Item eventKey="0">
              <Accordion.Header onClick={() => handleNavClick("/master")}>
                <FontAwesomeIcon icon={faUserTie} className="me-2" />
                Master
              </Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeLink === "/banners" ? "active" : ""}
                  onClick={() => handleNavClick("/banners")}
                  as={Link}
                  to={"/banners"}
                >
                  Banners
                </Nav.Link>
                <Nav.Link
                  className={activeLink === "/avatars" ? "active" : ""}
                  onClick={() => handleNavClick("/avatars")}
                  as={Link}
                  to={"/avatars"}
                >
                  Avatars
                </Nav.Link>
                <Nav.Link
                  className={activeLink === "/app-setup" ? "active" : ""}
                  onClick={() => handleNavClick("/app-setup")}
                  as={Link}
                  to={"/app-setup"}
                >
                  App Set Up
                </Nav.Link>

                <Nav.Link
                  className={activeLink === "/country" ? "active" : ""}
                  onClick={() => handleNavClick("/country")}
                  as={Link}
                  to={"/country"}
                >
                  Country
                </Nav.Link>

                <Nav.Link
                  className={activeLink === "/state" ? "active" : ""}
                  onClick={() => handleNavClick("/state")}
                  as={Link}
                  to={"/state"}
                >
                  State
                </Nav.Link>
                <Nav.Link
                  className={activeLink === "/city" ? "active" : ""}
                  onClick={() => handleNavClick("/city")}
                  as={Link}
                  to={"/city"}
                >
                  City
                </Nav.Link>

                <Nav.Link
                  className={activeLink === "/pincode" ? "active" : ""}
                  onClick={() => handleNavClick("/pincode")}
                  as={Link}
                  to={"/pincode"}
                >
                  Pincode
                </Nav.Link>

                {/* <Nav.Link
                  className={
                    activeLink === "/user-delete-reason" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/user-delete-reason")}
                  as={Link}
                  to={"/user-delete-reason"}
                >
                  User Delete Reasons
                </Nav.Link> */}
                {/* <Nav.Link
                  className={activeLink === "/travel-news" ? "active" : ""}
                  onClick={() => handleNavClick("/travel-news")}
                  as={Link}
                  to={"/travel-news"}
                >
                  Travel News
                </Nav.Link> */}
                <Nav.Link
                  className={activeLink === "/policy" ? "active" : ""}
                  onClick={() => handleNavClick("/policy")}
                  as={Link}
                  to={"/policy"}
                >
                  Policy
                </Nav.Link>
                {/* <Nav.Link
                  className={
                    activeLink === "/flight-account-setting" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/flight-account-setting")}
                  as={Link}
                  to={"/flight-account-setting"}
                >
                  Flight Account Setting
                </Nav.Link> */}
                {/* <Nav.Link
                  className={
                    activeLink === "/flight-prebooking-query" ? "active" : ""
                  }
                  onClick={() => handleNavClick("/flight-prebooking-query")}
                  as={Link}
                  to={"/flight-prebooking-query"}
                >
                  Flight Prebooking Query
                </Nav.Link> */}
                {/* 
                <Nav.Link
                  className={activeLink === "/feature-partners" ? "active" : ""}
                  onClick={() => handleNavClick("/feature-partners")}
                  as={Link}
                  to={"/feature-partners"}
                >
                  Feature Partners
                </Nav.Link> */}

                {/* <Nav.Link
                  className={activeLink === "/popular-search" ? "active" : ""}
                  onClick={() => handleNavClick("/popular-search")}
                  as={Link}
                  to={"/popular-search"}
                >
                  Popular Search
                </Nav.Link> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ) : (
          ""
        )}
        {usertype != "Agent" ? (
          <>
            <Accordion activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}>
              <Accordion.Item eventKey="2">
                <Accordion.Header onClick={() => handleNavClick("/customer")}>
                  <FontAwesomeIcon icon={faPeopleArrows} className="me-2" />
                  Customer Management
                </Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    className={
                      activeLink === "/customer/customer" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/customer/customer")}
                    as={Link}
                    to={"/customer/customer"}
                  >
                    Customer
                  </Nav.Link>
                  {/* <Nav.Link
                    className={
                      activeLink === "/inquiry/inquiry" ? "active" : ""
                    }
                    onClick={() => handleNavClick("/inquiry/inquiry")}
                    as={Link}
                    to={"/inquiry/inquiry"}
                  >
                    Support Inquiry
                  </Nav.Link> */}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>



            <Accordion
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
            >
              <Accordion.Item eventKey="6">
                <Accordion.Header
                  onClick={() => handleNavClick("/notifications")}
                >
                  <FontAwesomeIcon icon={faBell} className="me-2" />
                  Notifications
                </Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    className={activeLink === "/notifications" ? "active" : ""}
                    onClick={() => handleNavClick("/notifications")}
                    as={Link}
                    to={"/notifications"}
                  >
                    Notifications
                  </Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            {/* <Accordion
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
            >
              <Accordion.Item eventKey="7">
                <Accordion.Header onClick={() => handleNavClick("/support")}>
                  <FontAwesomeIcon icon={faHandHoldingHand} className="me-2" />
                  Support
                </Accordion.Header>
                <Accordion.Body>
                  <Nav.Link
                    className={
                      activeLink === "/support/payment-refund-questions"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleNavClick("/support/payment-refund-questions")
                    }
                    as={Link}
                    to={"/support/payment-refund-questions"}
                  >
                    Payment Refund Questions
                  </Nav.Link>

                  <Nav.Link
                    className={
                      activeLink === "/support/technical-support-questions"
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleNavClick("/support/technical-support-questions")
                    }
                    as={Link}
                    to={"/support/technical-support-questions"}
                  >
                    Technical Support Questions
                  </Nav.Link>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion> */}
          </>
        ) : (
          ""
        )}

        <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
          <Accordion.Item eventKey="8">
            <Accordion.Header onClick={() => handleNavClick("/wallet")}>
              <FontAwesomeIcon icon={faWallet} className="me-2" />
              Wallet Management{" "}
              {/* <div className="inner_accordion_text">
                {data?.wallet_count || 0}
              </div> */}
            </Accordion.Header>
            <Accordion.Body>
              <Nav.Link
                className={activeLink === "/wallet/history" ? "active" : ""}
                onClick={() => handleNavClick("/wallet/history")}
                as={Link}
                to={"/wallet/history"}
              >
                Wallet History
              </Nav.Link>
              <Nav.Link
                className={activeLink === "/wallet/request" ? "active" : ""}
                onClick={() => handleNavClick("/wallet/request")}
                as={Link}
                to={"/wallet/request"}
              >
                Wallet Requested{" "}
                {/* <div className="inner_accordion_text">
                  {data?.wallet_request_count || 0}
                </div> */}
              </Nav.Link>

              <Nav.Link
                className={activeLink === "/wallet/accept" ? "active" : ""}
                onClick={() => handleNavClick("/wallet/accept")}
                as={Link}
                to={"/wallet/accept"}
              >
                Wallet Accepted
              </Nav.Link>

              <Nav.Link
                className={activeLink === "/wallet/rejected" ? "active" : ""}
                onClick={() => handleNavClick("/wallet/rejected")}
                as={Link}
                to={"/wallet/rejected"}
              >
                Wallet Rejected
              </Nav.Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Accordion
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
        >
          <Accordion.Item eventKey="9">
            <Accordion.Header
              onClick={() => handleNavClick("/notifications")}
            >
              <FontAwesomeIcon icon={faLeaf} className="me-2" />
              Titli Soorat
            </Accordion.Header>
            <Accordion.Body>
              <Nav.Link
                className={activeLink === "/titli-history" ? "active" : ""}
                onClick={() => handleNavClick("/titli-history")}
                as={Link}
                to={"/titli-history"}
              >
                Game History
              </Nav.Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>



        <Accordion
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
        >
          <Accordion.Item eventKey="10">
            <Accordion.Header
              onClick={() => handleNavClick("/notifications")}
            >
              <FontAwesomeIcon icon={faDice} className="me-2" />
              Roulette
            </Accordion.Header>
            <Accordion.Body>

              <Nav.Link
                className={activeLink === "/roulette-payout" ? "active" : ""}
                onClick={() => handleNavClick("/roulette-payout")}
                as={Link}
                to={"/roulette-payout"}
              >
                Roulette Payout
              </Nav.Link>
              <Nav.Link
                className={activeLink === "/roulette-history" ? "active" : ""}
                onClick={() => handleNavClick("/roulette-history")}
                as={Link}
                to={"/roulette-history"}
              >
                Roulette Game History
              </Nav.Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {/* <Accordion>
          <Accordion.Item eventKey="1">
            <Accordion.Header onClick={() => handleNavClick("/app_setup")}>
              <FontAwesomeIcon icon={faAnglesRight} className="me-2" />
              App Setup
            </Accordion.Header>
            <Accordion.Body>
              <Nav.Link
                className={activeLink === "/social-media" ? "active" : ""}
                onClick={() => handleNavClick("/social-media")}
                as={Link}
                to={"/social-media"}
              >
                Social Media
              </Nav.Link>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion> */}
      </Nav>
    </section>
  );
}

export default Sidebar;
